"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tinycolor2_1 = __importDefault(require("tinycolor2"));

var lodash_1 = __importDefault(require("lodash"));

function isStop(stop) {
  return stop.color !== undefined;
}
/* infer color positions, equally spaced on order */


function getPositions(colorScale) {
  var lastLow = 0,
      lowIndex = 0;
  var res = [];

  for (var i = 0; i < colorScale.length; i++) {
    var highIndex = colorScale.length - 1,
        nextHigh = 1;
    var stop_1 = colorScale[i];

    if (isStop(stop_1)) {
      lastLow = stop_1.pos;
      lowIndex = i;
      res.push(stop_1);
    } else {
      for (var j = i + 1; j < colorScale.length; j++) {
        var nextColor = colorScale[j];

        if (isStop(nextColor)) {
          nextHigh = nextColor.pos;
          highIndex = j;
          break;
        }
      }

      var slope = (nextHigh - lastLow) / (highIndex - lowIndex);
      res.push({
        color: stop_1,
        pos: lastLow + slope * (i - lowIndex)
      });
    }
  }

  return res;
}

exports.getPositions = getPositions;

function interpolateColor(scale, value) {
  value = Math.min(Math.max(value, 0), 1); //clip value

  /* find which two colors [color, nextColor] the value is between */

  var color, i;

  for (i = 0; i < scale.length; i++) {
    color = scale[i];
    if (color.pos <= value && (!scale[i + 1] || scale[i + 1].pos > value)) break;
  }

  var nextColor = scale[i + 1];
  if (!nextColor) return color.color;
  var dpos = nextColor.pos - color.pos,
      vald = value - color.pos,
      ratio = vald / dpos;
  return tinycolor2_1.default.mix(color.color, nextColor.color, ratio * 100).toHexString();
}

function getColors(primary, secondary, primaryLum, secondaryLum) {
  var primaryStops = getPositions(primary),
      secondaryStops = getPositions(secondary),
      ffrac = (primaryLum + 1) / 2,
      bfrac = (secondaryLum + 1) / 2,
      diff = bfrac - ffrac,
      bqContrast = diff * diff * diff * diff * diff; //diff^3

  /* try and overshoot bwfrac unless it overflows pass [-.2, 1.2] */

  var bqfrac = bfrac + bqContrast;
  /* if overshoot has too little contrast or diff > 0 (d on l) dont do overshoot */

  if (diff > 0 || bqfrac < -0.2 || bqfrac > 1.2) {
    bqfrac = bfrac - bqContrast;
  }

  return {
    fg: interpolateColor(primaryStops, ffrac),
    bg: interpolateColor(secondaryStops, bfrac),
    bq: interpolateColor(primaryStops, bqfrac),
    interp: function interp(v, secondary) {
      return interpolateColor(secondary ? secondaryStops : primaryStops, ffrac + (1 - v) * diff);
    }
  };
}

var Color =
/** @class */
function () {
  function Color(primary, secondary, lum, contrast, inverted) {
    var _this = this;

    this.nudge = lodash_1.default.memoize(function (diff) {
      var invcoeff = 1;
      var scaledDiff = diff * (1 + _this.contrastVal * 3);
      var newlum = _this.lum + scaledDiff * invcoeff;
      if (newlum > 1 || newlum < -1) newlum = _this.lum - scaledDiff * invcoeff;
      return new Color(_this.primary, _this.secondary, newlum, _this.contrastVal, _this.inverted);
    });
    this.contrast = lodash_1.default.memoize(function (diff) {
      var newcontrast = Math.max(Math.min(_this.contrastVal + diff, 1), 0);
      return new Color(_this.primary, _this.secondary, _this.lum, newcontrast, _this.inverted);
    });
    this.invert = lodash_1.default.memoize(function () {
      return new Color(_this.primary, _this.secondary, _this.lum, _this.contrastVal, !_this.inverted);
    });
    this.as = lodash_1.default.memoize(function (newPrimary, newSecondary) {
      return new Color(newPrimary, newSecondary, _this.lum, _this.contrastVal, _this.inverted);
    });
    this.toString = lodash_1.default.memoize(function () {
      return _this.fg + ", " + _this.bg;
    });

    this.serial = function () {
      return {
        secondary: _this.secondary,
        primary: _this.primary,
        lum: _this.lum,
        contrast: _this.contrastVal,
        inverted: _this.inverted
      };
    };

    this.unserial = function (serial) {
      var secondary = serial.secondary,
          primary = serial.primary,
          lum = serial.lum,
          contrast = serial.contrast,
          inverted = serial.inverted,
          nudgecoeff = serial.nudgecoeff;
      return new Color(secondary, primary, lum, contrast, inverted);
    };

    this.absLum = lodash_1.default.memoize(function (newLum) {
      return new Color(_this.secondary, _this.primary, newLum, _this.contrastVal, _this.inverted);
    });
    this.absContrast = lodash_1.default.memoize(function (newContrast) {
      return new Color(_this.secondary, _this.primary, _this.lum, newContrast, _this.inverted);
    });
    this.primary = primary || ['black', 'white'];
    this.secondary = secondary || this.primary;
    this.lum = lum || 0;
    this.contrastVal = contrast === undefined ? 0.5 : contrast;
    this.inverted = inverted;
    this.wtf = 666;

    var invcoeff = inverted ? -1 : 1,
        range = this.contrastVal * 2,
        normLum = (this.lum * invcoeff + 1) / 2,
        base = (2 - range) * normLum,
        primaryLum = (-1 + base) * invcoeff,
        secondaryLum = (-1 + base + range) * invcoeff,
        _a = getColors(this.primary, this.secondary, primaryLum, secondaryLum),
        fg = _a.fg,
        bq = _a.bq,
        bg = _a.bg,
        interp = _a.interp;

    this.fg = fg;
    this.bg = bg;
    this.bq = bq;
    this.interp = interp;
  }

  return Color;
}();

exports.default = Color;